import React from 'react';
import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/outline';

interface MetricCardProps {
  title: string;
  value: string | number;
  trend?: 'up' | 'down' | 'neutral';
  subtitle?: string;
  icon?: React.ComponentType<{ className?: string }>;
}

export const MetricCard: React.FC<MetricCardProps> = ({ 
  title, 
  value, 
  trend, 
  subtitle, 
  icon: Icon 
}) => {
  const getTrendIcon = () => {
    if (trend === 'up') return <ArrowUpIcon className="h-4 w-4 text-success-500" />;
    if (trend === 'down') return <ArrowDownIcon className="h-4 w-4 text-danger-500" />;
    return null;
  };

  const getTrendColor = () => {
    if (trend === 'up') return 'text-success-600';
    if (trend === 'down') return 'text-danger-600';
    return 'text-secondary-600';
  };

  return (
    <div className="metric-card">
      <div className="relative">
        <div className="flex items-center justify-between mb-4">
          {Icon && (
            <div className="p-2 bg-gradient-to-br from-primary-100 to-primary-200 rounded-lg group-hover:scale-105 transition-transform duration-300">
              <Icon className="h-5 w-5 text-primary-600" />
            </div>
          )}
          <div className="text-right">
            <p className="text-xs sm:text-sm text-secondary-500 uppercase tracking-wide font-medium">
              {title}
            </p>
            <div className="text-2xl sm:text-3xl font-bold text-secondary-900 group-hover:text-primary-700 transition-colors">
              <span className="counter">{value}</span>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between">
          {subtitle && (
            <div className="flex items-center text-xs sm:text-sm">
              <span className="text-secondary-600 font-medium">
                {subtitle}
              </span>
            </div>
          )}
          {trend && (
            <div className={`flex items-center space-x-1 text-xs font-medium ${getTrendColor()}`}>
              {getTrendIcon()}
              <span>{trend}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
